import { createContext, useCallback, useState } from "react"
import { updateTheme as updateThemeApi } from "../services/api/ThemeDataService"


export const VibioThemeContext = createContext()

// The fields the backend's ThemeInput accepts (themeId is path-only, never in the body).
function toThemeInput(theme) {
    return {
        bgColor: theme.bgColor,
        iconColor: theme.iconColor,
        buttonColor: theme.buttonColor,
        fontStyle: theme.fontStyle,
        buttonStyle: theme.buttonStyle,
    }
}

export const VibioThemeProvider = ({ children }) => {
    const [theme, setTheme] = useState(null)

    // Pure state set — used to seed the theme (e.g. from the loaded page).
    const updateTheme = useCallback((newTheme) => setTheme(newTheme), [])

    // Merge one change, reflect it instantly (live preview), and persist the whole theme.
    const saveThemeChange = useCallback((change) => {
        setTheme((current) => {
            if (!current) return current
            const next = { ...current, ...change }
            if (next.themeId) {
                updateThemeApi(next.themeId, toThemeInput(next))
                    .catch((error) => console.error('Failed to save theme', error))
            }
            return next
        })
    }, [])

    return (
        <VibioThemeContext.Provider value={{ theme, updateTheme, saveThemeChange }}>
            {children}
        </VibioThemeContext.Provider>
    )
}
